import { Link } from "react-router-dom";
import { Target, SignIn, ArrowRight } from "@phosphor-icons/react";
import { LANDING } from "@/constants/testIds";

export default function Landing() {
  return (
    <div className="min-h-screen bg-obsidian relative overflow-hidden flex flex-col">
      <div className="grain absolute inset-0 pointer-events-none" />

      {/* Top bar */}
      <header className="relative max-w-5xl w-full mx-auto px-6 lg:px-10 py-6 flex items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 bg-neon-cyan flex items-center justify-center">
            <Target size={22} weight="bold" color="#050505" />
          </div>
          <span className="display-heading font-black text-lg tracking-tight">
            Liquid RP <span className="text-neon-cyan">Creators</span>
          </span>
        </div>
        <Link to="/owner/login" data-testid="nav-owner-login"
          className="text-white/40 hover:text-neon-cyan transition-colors text-xs font-mono inline-flex items-center gap-1.5 uppercase tracking-wide">
          Owner Console <ArrowRight size={12} weight="bold" />
        </Link>
      </header>

      {/* Center */}
      <main className="relative flex-1 flex items-center">
        <div className="max-w-5xl w-full mx-auto px-6 lg:px-10 py-16">
          <div className="max-w-xl">
            <div className="kbd-label mb-4 text-neon-cyan">// INTERNAL CREATOR TRACKING</div>
            <h1 className="display-heading text-4xl sm:text-5xl lg:text-6xl font-black leading-[0.95]">
              Liquid RP<br /><span className="text-neon-cyan">Creator Portal</span>
            </h1>
            <p className="mt-5 text-white/60 text-base sm:text-lg font-mono">
              Track your referrals, members, and earnings for Liquid RP — all in one place.
            </p>

            <div className="mt-10 flex flex-col sm:flex-row gap-4">
              <Link to="/creator/login" data-testid={LANDING.heroCta}
                className="neon-btn px-6 py-4 inline-flex items-center justify-center gap-2 text-base">
                <SignIn size={20} weight="bold" /> CREATOR SIGN IN
              </Link>
            </div>
          </div>
        </div>
      </main>

      <footer className="relative max-w-5xl w-full mx-auto px-6 lg:px-10 py-8 kbd-label text-white/40 flex justify-between items-center flex-wrap gap-3">
        <span>LIQUID RP CREATORS</span>
        <div className="flex items-center gap-5">
          <a href="/privacy" className="hover:text-neon-cyan transition-colors" data-testid="footer-privacy-link">PRIVACY</a>
          <a href="/terms" className="hover:text-neon-cyan transition-colors" data-testid="footer-terms-link">TERMS</a>
          <span className="text-neon-cyan">INTERNAL TOOL</span>
        </div>
      </footer>
    </div>
  );
}
